import { formatCurrency, formatDate } from "../../../utils/formatters";
import Badge from "../../common/Badge";
import { Wallet, Building2, CheckCircle2 } from "lucide-react";

const statusVariant = (status) => {
  switch (status?.toLowerCase()) {
    case "completed":
      return "success";
    case "pending":
      return "warning";
    case "failed":
      return "danger";
    default:
      return "default";
  }
};

const PayoutsTable = ({ payouts, loading, onApprove }) => (
  <div className="bg-bg-surface border border-border rounded-xl overflow-hidden">
    <table className="w-full text-sm">
      <thead className="bg-bg-elevated text-text-muted text-xs uppercase">
        <tr>
          <th className="px-5 py-3 text-left">Hub</th>
          <th className="px-5 py-3 text-left">Event</th>
          <th className="px-5 py-3 text-left">Reference</th>
          <th className="px-5 py-3 text-left">Amount</th>
          <th className="px-5 py-3 text-left">Status</th>
          <th className="px-5 py-3 text-left">Requested</th>
          <th className="px-5 py-3" />
        </tr>
      </thead>
      <tbody className="divide-y divide-border">
        {loading ? (
          Array.from({ length: 6 }).map((_, i) => (
            <tr key={i} className="animate-pulse">
              {Array.from({ length: 7 }).map((_, j) => (
                <td key={j} className="px-5 py-3">
                  <div className="h-4 bg-bg-elevated rounded w-24" />
                </td>
              ))}
            </tr>
          ))
        ) : payouts.length === 0 ? (
          <tr>
            <td colSpan={7} className="px-5 py-12 text-center">
              <Wallet size={24} className="text-border-hover mx-auto mb-2" />
              <p className="text-xs text-text-muted">No payouts found</p>
            </td>
          </tr>
        ) : (
          payouts.map((payout) => (
            <tr key={payout.id} className="hover:bg-bg-elevated transition">
              <td className="px-5 py-3">
                <div className="flex items-center gap-2">
                  {payout.hubImage ? (
                    <img
                      src={payout.hubImage}
                      alt=""
                      className="w-7 h-7 rounded-md object-cover"
                    />
                  ) : (
                    <div className="w-7 h-7 rounded-md bg-bg-elevated flex items-center justify-center">
                      <Building2 size={13} className="text-text-muted" />
                    </div>
                  )}
                  <div>
                    <p className="text-text-primary font-medium text-sm">
                      {payout.hubName}
                    </p>
                    <p className="text-xs text-text-muted">
                      {payout.ownerEmail}
                    </p>
                  </div>
                </div>
              </td>
              <td className="px-5 py-3 text-text-secondary text-sm max-w-[160px] truncate">
                {payout.eventTitle}
              </td>
              <td className="px-5 py-3">
                <code className="text-xs bg-bg-elevated px-2 py-0.5 rounded text-text-muted">
                  {payout.reference}
                </code>
              </td>
              <td className="px-5 py-3">
                <p className="text-sm font-semibold text-primary">
                  {formatCurrency(payout.hubCommission)}
                </p>
                <p className="text-xs text-text-muted">
                  of {formatCurrency(payout.grossAmount)}
                </p>
              </td>
              <td className="px-5 py-3">
                <Badge
                  label={payout.status}
                  variant={statusVariant(payout.status)}
                />
              </td>
              <td className="px-5 py-3 text-text-muted text-xs">
                {formatDate(payout.requestedAt)}
              </td>
              <td className="px-5 py-3 text-right">
                {payout.status?.toLowerCase() === "pending" && (
                  <button
                    onClick={() => onApprove(payout)}
                    className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-primary/10 text-primary border border-primary/20 text-xs font-medium hover:bg-primary/20 transition"
                  >
                    <CheckCircle2 size={13} />
                    Approve
                  </button>
                )}
              </td>
            </tr>
          ))
        )}
      </tbody>
    </table>
  </div>
);

export default PayoutsTable;
